/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useState } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import styles from './TopicToc.module.scss';

import type { TopicTocProps } from './TopicToc.types';

type TocItem = { id: string; title: string };

export const TopicToc = ({ contentId, className }: TopicTocProps) => {
  const { t } = useInt();
  const [items, setItems] = useState<TocItem[]>([]);
  const [active, setActive] = useState('');

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll<HTMLElement>(`#${contentId} > [id]`)).filter((section) =>
      section.querySelector('h2'),
    );

    setItems(sections.map((section) => ({ id: section.id, title: section.querySelector('h2')?.textContent ?? '' })));

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);

        if (visible) {
          setActive(visible.target.id);
        }
      },
      { rootMargin: '-120px 0px -60% 0px' },
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [contentId]);

  if (!items.length) {
    return null;
  }

  return (
    <nav aria-label={t('In this guide')} className={cn(styles['toc'], className)}>
      <p className={styles['label']}>{t('In this guide')}</p>

      <ul className={styles['list']}>
        {items.map((item) => (
          <li key={item.id}>
            <a href={`#${item.id}`} className={cn(styles['link'], active === item.id && styles['active'])}>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
